import React from 'react';
import './Info.css';

const Terms = () => {
    return (
        <div className="info-page">
            <header className="info-hero">
                <div className="container">
                    <span className="section-eyebrow">LEGAL COMPLIANCE</span>
                    <h1 className="terminal-title">Terms & Conditions</h1>
                    <p className="terminal-desc">These terms govern your elite interaction and professional use of the Bharatinsurex platform.</p>
                </div>
                <div className="info-hero-orb"></div>
            </header>

            <main className="info-container">
                <section className="info-content">
                    <h2>Terms of Service</h2>
                    <p>Welcome to Bharatinsurex. By accessing or using our platform, you agree to comply with and be bound by the following terms and conditions of use, which together with our privacy policy govern Bharatinsurex's relationship with you in relation to this website and its services.</p>
                    
                    <h3>1. Professional Use</h3>
                    <p>The content of the pages of this website is for your general information and use only. It is subject to change without notice. Unauthorized use of this website may give rise to a claim for damages and/or be a criminal offense.</p>

                    <h3>2. Accuracy & Liability</h3>
                    <p>Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials found or offered on this website for any particular purpose.</p>

                    <h3>3. Links to Other Websites</h3>
                    <p>From time to time this website may also include links to other websites. These links are provided for your convenience to provide further information. They do not signify that we endorse the website(s). We have no responsibility for the content of the linked website(s).</p>

                    <h3>4. Intellectual Property</h3>
                    <p>This website contains material which is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.</p>

                    <h3>5. Governing Law</h3>
                    <p>Your use of this website and any dispute arising out of such use of the website is subject to the local laws of the Republic of India.</p>
                </section>
            </main>
        </div>
    );
};

export default Terms;
